import { Box, Container, styled as muiStyled } from '@mui/material'
import styled from 'styled-components'
import theme from '../../../../theme'

export const HomeContainer = muiStyled(Container)(() => {
  return {
    flex: 1,
  }
})

export const HomeRestaurantCardContainer = styled(Box).attrs<{ mb?: string }>((props) => ({
  sx: {
    padding: { xs: '32px 0', md: '48px 0' },
    marginBottom: props.mb ?? '0px',
  },
}))`
  /* Ensure clean section breaks */
  border-bottom: 1px solid ${theme.palette.divider};

  &:last-of-type {
    border-bottom: none;
  }
`
